import React, {createContext, Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import UserStore from "./store/UserStore";
import AddStore from "./store/AddStore";
import FilterStore from './store/FilterStore';
import HelperStore from "./store/HelperStore";

import ApartmentChatStore from "./store/ApartmentChatStore";
import DirectChatStore from "./store/DirectChatStore";
import RequestChatStore from "./store/RequestChatStore";
import MessagesStore from "./store/MessagesStore";

import {SocketProvider} from "./store/SocketContext";
import Loading from "./components/commons/Loading/Loading";

export const Context = createContext(null);

const user = new UserStore();
const add = new AddStore();
const filter = new FilterStore();
const helper = new HelperStore();

const apartmentChat = new ApartmentChatStore();
const directChat = new DirectChatStore();
const requestChat = new RequestChatStore();

const messages = new MessagesStore({
    apartmentChat,
    directChat,
    requestChat
});

ReactDOM.render(
    <Suspense fallback={<Loading />}>
        <Context.Provider value={{
            user,
            add,
            filter,
            helper,

            apartmentChat,
            directChat,
            requestChat,
            messages
        }}>
            <SocketProvider>
                <App/>
            </SocketProvider>
        </Context.Provider>
    </Suspense>,
    document.getElementById('root')
);